import AbstractFilter from '@/classes/filters/AbstractFilter'

export default class DateFilter extends AbstractFilter {
  /**
   * Create new date filter
   *
   * @param {String} key
   * @param {String} property
   * @param {String|Date} [value]
   */
  constructor (key, property, value) {
    super(key, null, property, value)

    if (value && !(value instanceof Date)) {
      this._value = new Date(value)
    }
  }

  /**
   * Get value of this filter
   *
   * @return {String}
   */
  toString () {
    return this.value ? this.value.toISOString() : ''
  }
}
